export const EVENT_LABELS = {
  DATASET_QA_VALIDATION_DURATION_SECONDS: 'dataset_qa_validation_duration_seconds',
  DATASET_QA_VALIDATION_NUMBER_OF_IMAGES: 'dataset_qa_validation_number_of_images',
  DATASET_QA_IMAGE_DELETED: 'dataset_qa_image_deleted',
  DATASET_QA_IMAGE_UNDELETED: 'dataset_qa_image_undeleted',
  PRODUCT_QA_INTERNAL_NAME_CHANGED: 'product_qa_internal_name_changed',
  PRODUCT_QA_WEIGHT_CHANGED: 'product_qa_weight_changed',
  PRODUCT_QA_IMAGE_UPDATED: 'product_qa_image_updated',
  PRODUCT_QA_IMAGE_UPLOADED: 'product_qa_image_uploaded',
  PRODUCT_QA_STATUS_APPROVED: 'product_qa_status_approved',
  PRODUCT_QA_STATUS_REJECTED: 'product_qa_status_rejected',
  PLANOGRAM_TICKET_VALIDATION_DURATION_SECONDS: 'planogram_ticket_validation_duration_seconds',
} as const;

export interface EventMetric {
  label: (typeof EVENT_LABELS)[keyof typeof EVENT_LABELS];
  value: number;
  app_name: string;
  environment: string;
  tags: Record<string, string>;
}

export interface ProductQAEditEvent {
  productId: number;
  qaStatusApproved: boolean;
  qaStatusRejected: boolean;
  internalNameChanged: boolean;
  weightChanged: boolean;
  updatedImages: number;
  newImages: number;
}
